import { type Organization, type ProgramTheme, type WithOrganization } from "../types/types";
import { getSafe } from "../utils/getSafe";

export const isOpenOrganization = (organization?: Organization): boolean =>
  getSafe(() => organization.id) === 0 && getSafe(() => organization.name, "").length > 0;

export const shouldCollectPostalCode = (programTheme: ProgramTheme, viewModel: WithOrganization) =>
  getSafe(() => programTheme.openOrgSearchEnabled) && isOpenOrganization(viewModel.organization);
